import { render, staticRenderFns } from "./CostElementCommitmentItem.vue?vue&type=template&id=2dafe6df&scoped=true&"
import script from "./CostElementCommitmentItem.vue?vue&type=script&lang=js&"
export * from "./CostElementCommitmentItem.vue?vue&type=script&lang=js&"
import style0 from "./CostElementCommitmentItem.vue?vue&type=style&index=0&id=2dafe6df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dafe6df",
  null
  
)

export default component.exports